import script from "./ApeConstructorTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ApeConstructorTabs.vue?vue&type=script&setup=true&lang=js"

import "./ApeConstructorTabs.vue?vue&type=style&index=0&id=3625c82a&lang=scss"

const __exports__ = script;

export default __exports__